import React from "react";
import ProjectsTable from "../../Components/ProjectsTable";
import {Column, Container, Wrapper} from "../../hoc/Layout";
import {FormattedMessage} from "react-intl";

import classes from "./styles.module.css";

export default function Payouts() {
    return (

        <Wrapper>
            <Container style={{justifyContent: 'center'}}>
                <Column width={'100%'}>
                    <div className={classes.Card}>
                        <div className={classes.Header}>
                            <h5 className={classes.Title}>
                                <FormattedMessage
                                    id="Payouts.title"
                                    defaultMessage="Проекты"
                                />
                            </h5>
                        </div>

                        <div className={classes.TableWrap}>
                            <ProjectsTable/>
                        </div>
                    </div>
                </Column>
            </Container>
        </Wrapper>
    )
        ;
}



// WEBPACK FOOTER //
// ./src/PagesOfUser/Projects/index.js